// Offre de retour : -50 % pendant 2 mois sur Believemy Pro sans engagement,
// proposée à un ancien abonné Pro. Ces constantes sont lues des deux côtés
// (affichage et paiement) : le montant débité vient de create-payment-intent,
// jamais du navigateur.

export const WINBACK_CHECKOUT_TYPE = "winback";
export const WINBACK_DISCOUNT_PERCENT = 50;
export const WINBACK_DISCOUNT_MONTHS = 2;

/**
 * Prix mensuel remisé, à partir du prix mensuel sans engagement.
 *
 * @param {string|number} monthlyPrice prix catalogue ("79", "79,00")
 * @returns {number}
 */
export function getWinbackPrice(monthlyPrice) {
    const base = parseFloat(String(monthlyPrice).replace(",", "."));
    if (Number.isNaN(base)) return 0;
    return Math.round(base * (100 - WINBACK_DISCOUNT_PERCENT)) / 100;
}
